import {
  AppSyncProviderType,
  AppSyncStateContext,
} from 'components/AppSyncProvider';
import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const AppSyncMockProvider: React.FC<Props> = ({ children }) => {
  const mockAppSyncProviderValues: AppSyncProviderType = {
    isClientReady: true,
    setIsClientReady: () => {},
    setConnectedEvent: () => {},
  };

  return (
    <AppSyncStateContext.Provider value={mockAppSyncProviderValues}>
      {children}
    </AppSyncStateContext.Provider>
  );
};
